module.exports = "https://cdn.ticketswap.com/_next/static/images/vouchers-day-out-0d3d90e67267362d4f584b19580e87bc.jpg";